import React from 'react';
import {Card,Button} from 'react-bootstrap'
import styled from 'styled-components'

const StyledHeader = styled(Card.Title)`
    font-size: 2rem;
    font-weight: normal;
    letter-spacing: 0.1rem;
`
const StyledAuthor = styled(Card.Title)`
    font-weight: lighter;
`
const StyledText = styled(Card.Text)`
    text-align: left;
`
const StyledButton = styled(Button)`
    background: rgb(65, 80, 120);
    border: rgb(65, 80, 120);
`

const LongCardInverted = ({text, title, writer}) => {
    return (
        <Card style={{ width: '100%', background: 'rgb(232, 232, 232)', border: '0', "margin-top": '30px'}}>
            <div className="row" style={{ padding: '2.5rem 2rem'}}>
                <div className="col-sm-6">
                    <Card.Body>
                        <StyledHeader>{title}</StyledHeader>
                        <StyledAuthor>{writer}</StyledAuthor>
                        <StyledText>
                            {text}
                        </StyledText>
                        <StyledButton variant="dark">Read Article</StyledButton>
                    </Card.Body>
                </div>
                <div className="col-sm-6">
                    <Card.Img variant="top" src='https://images.theconversation.com/files/336248/original/file-20200520-152302-97x8pw.jpg?ixlib=rb-1.1.0&q=45&auto=format&w=1200&h=1200.0&fit=crop' />
                </div>
            </div>
            
        </Card>
    );
}

export default LongCardInverted;